import { actionChannel, put, select, take, takeLatest } from "redux-saga/effects";
import { PreferredAngles } from "../../../models/preferredAngles";
import {
    SET_ACTIVE_SERIES_AND_FRAME,
    SET_ACTIVE_VIEW_INDEX,
    STEP_FRAME_LEFT,
    STEP_FRAME_RIGHT,
    TRIGGER_PREFERRED_ANGLE,
} from "../../actions/viewActions";
import { getActiveFrame, getActiveImageSeriesId, getActiveViewIndex, getMaxViewIndex } from "../selectors";

export function* stepFrameSaga(): any {
    const channel = yield actionChannel([STEP_FRAME_LEFT, STEP_FRAME_RIGHT]);
    while (true) {
        const action = yield take(channel);
        const viewIndex = yield select(getActiveViewIndex);
        const maxViewIndex = yield select(getMaxViewIndex);
        let newViewIndex = action.type === STEP_FRAME_LEFT ? viewIndex + 1 : viewIndex - 1;
        newViewIndex = Math.max(Math.min(newViewIndex, maxViewIndex), 0);
        if (newViewIndex !== viewIndex) {
            yield put({
                type: SET_ACTIVE_VIEW_INDEX,
                activeViewIndex: newViewIndex,
            });
        }
    }
}

export function* triggerPreferredAngleSaga(): any {
    yield takeLatest(TRIGGER_PREFERRED_ANGLE, function* (action: any): any {
        const activeSeries: string | null = yield select(getActiveImageSeriesId);
        const activeFrame: number | null = yield select(getActiveFrame);
        if (!activeSeries || activeFrame === null) return;

        const { series, frames }: PreferredAngles = action.preferredAngles;
        if (activeSeries !== series || !frames.includes(activeFrame)) {
            yield put({
                type: SET_ACTIVE_SERIES_AND_FRAME,
                activeSeriesId: series,
                activeFrame: frames[0],
            });
        }
    });
}
